import React from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import TestDriveDevSidebar from './TestDriveDevSidebar';
const TD_TRY_ANOTHER_HELP = `
  <div>
    <p>Just like test-driving a car might involve some city driving and some highway driving, an Access Navigator Test-drive can include more than one activity. 
    You can choose how many activities to do within this Test-drive. 
    </p>
    <p>
    Keep in mind that you generally want to keep the access method setup the same throughout a Test-drive.  
    (Just like you would only test-drive one car at a time.)   
    </p>  
    <p>
    <strong>Reasons to do another activity:</strong> the first activity showed promise, but you want to explore use of this access method further. 
    Maybe the first activity was something fairly simple, and the next one could be something a bit more complex. 
    Or maybe the first activity was one of your own activities, and with the second one, you want to use an in-app activity to take some measurements.
    </p>
    <p>
    <strong>Reasons to end the Test-drive:</strong> If it’s obvious from the first activity that this access method setup is not a good fit, feel free to stop.  
    Or if you’ve done several activities in this Test-drive, you may have learned all you can for now. 
    </p>
    <p>
    Basically, it’s up to you and your client to decide how much information you need, and that will determine when to end the Test-drive.   
    You can always run more Test-drives with an access method if you want to later. 
    </p>
  </div>
`;

const propTypes = {
  doAnotherActivity: PropTypes.string,
  onChangeDoAnotherActivity: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  doAnotherActivity: '',
};

//content sub-component with unique content for this page
function TestDriveTryAnotherContent(props) {
  const doAnotherActivity = props.doAnotherActivity;
  const onChangeDoAnotherActivity = props.onChangeDoAnotherActivity;

  const anotherActivityBtns = [
    {
      value: 'true',
      label: `Yes, let's keep test-driving this same access method setup`,
      moreInfo: ''
    },
    {
      value: 'false',
      label: `No, let's finish and rate this test-drive`,
      moreInfo: ''
    }
  ];
  return(
    <>
    <p>If you feel you've learned enough about this access method for now, 
      feel free to end the Test-drive.</p>
    <p>Or, you might want to do another activity and keep test-driving this access method in order to explore further.</p>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Do you want to do another activity as part of this Test-drive?</legend>
        {anotherActivityBtns.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={doAnotherActivity===btn.value}
              onChange={onChangeDoAnotherActivity}
              name="do-another-activity"
              type="radio"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
            </Label>
          </FormGroup>
        )}
      </FormGroup>
    </Form>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveTryAnother(props) {
  const doAnotherActivity = props.doAnotherActivity;
  const onChangeDoAnotherActivity = props.onChangeDoAnotherActivity;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-road aa-fa-3x",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Do you want to do another activity in this Test-drive?`,
    subTitle: '',
    learnMore: {linkText: "Learn More about activities within a Test-drive",
                title: "Activities within a Test-drive",
                content: TD_TRY_ANOTHER_HELP
                },
    nextRoute: "",
    sidebar: false
  }

  console.log("Rendering TestDriveTryAnother, doAnotherActivity is: " + doAnotherActivity);
  
  //there is no useEffect() method because we aren't saving anything here to global Sesion
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveTryAnotherContent 
          doAnotherActivity={doAnotherActivity}
          onChangeDoAnotherActivity={onChangeDoAnotherActivity}
        />
      }
      sidebarComponent = {
        dev.showDevSidebar && 
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
       />
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveTryAnother.propTypes = propTypes;
TestDriveTryAnother.defaultProps = defaultProps;

export default TestDriveTryAnother;